import React from 'react';
import styled, { css } from 'styled-components';
import colors from '../../../vars/colors';
import breakpoints from '../../../vars/breakpoints';
import gutters from '../../../vars/gutters';

export const FWAWrapper = styled.div`
    .assetHolder:hover {
        .stripes {
            animation-play-state: paused;
        }
    }
`;

export const ColorBlock = styled.div`
    position: absolute;
    top: 50%;
    overflow: hidden;
    bottom: calc(${gutters['container-gutters-desktop-l']} * -0.7);
    left: calc(${gutters['container-gutters-desktop-l']} * -0.8);
    right: calc(${gutters['container-gutters-desktop-l']} * -0.8);
    z-index: -1;
    @media (max-width: ${breakpoints['bp-desktop']}) {
        bottom: calc(${gutters['container-gutters-desktop']} * -0.7);
        left: calc(${gutters['container-gutters-desktop']} * -0.8);
        right: calc(${gutters['container-gutters-desktop']} * -0.8);
    }
    @media (max-width: ${breakpoints['bp-tablet']}) {
        bottom: calc(${gutters['container-gutters-tablet']} * -0.7);
        left: calc(${gutters['container-gutters-tablet']} * -0.8);
        right: calc(${gutters['container-gutters-tablet']} * -0.8);
    }
    @media (max-width: ${breakpoints['bp-mobile']}) { 
        bottom: calc(${gutters['container-gutters-mobile']} * -2);
        left: calc(${gutters['container-gutters-mobile']} * -1);
        right: calc(${gutters['container-gutters-mobile']} * -1);
    }
    .stripes {
        position: absolute;
        top: -75px;
        left: -75px;
        right: -75px;
        bottom: -75px;
        background: repeating-linear-gradient(-45deg, ${props => props.color === 'blue' ? colors['peacock-blue'] : colors['lipstick']}, ${props => props.color === 'blue' ? colors['peacock-blue'] : colors['lipstick']} 25px, rgba(255, 255, 255, 0.5) 25px, rgba(255, 255, 255, 0.5) 50px);
        animation-name: barbersPole;
        animation-timing-function: linear;
        animation-iteration-count: infinite;
        animation-duration: 1200ms;
        animation-play-state: running;
        @keyframes barbersPole {
            0% {transform: translate3d(0, 0, 0)}
            100% {transform: translate3d(0, 72px, 0)}
        }
    }    
`;


// WEBPACK FOOTER //
// ./src/components/modules/FullWidthAsset/styled-components.js